import template from './dashboardNotifications.html';
import controller from './dashboardNotifications.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    notifications: '<',
    onDismissNotification: '&',
  }
};

export default component;
